export const endpoints = {
  guidLogin: 'api/users/guid_login',

  //Category
  createCategory: 'api/category/create',
  createSubCategory: 'api/category/create_subcategory',
  createTopic: 'api/topic/create',
  getAllCategories: 'api/category/all',
  getAllSubCategories: 'api/category',
  getAllTopics: 'api/topic',
  deleteCategory: 'api/category/delete',
  deleteTopic: 'api/topic/delete',

  //Department
  getAllDepartments: 'api/departments/v2/all',
  getOneDepartment: 'api/departments/find',
  updateDepartment: 'api/departments/update',
  deleteDepartment: 'api/departments/delete',
  createDepartment: 'api/departments/create',

  //Division
  getAllDivisionsByDepartment: 'api/divisions',
  getAllDivisions: 'api/divisions/all',
  getOneDivision: 'api/divisions',
  updateDivision: 'api/divisions',
  deleteDivision: 'api/divisions/delete',
  createDivision: 'api/divisions',

  //Unit
  getAllUnits: 'api/units/all',
  getAllUnitsByDivision: 'api/units',
  getOneUnit: 'api/units',
  updateUnit: 'api/units',
  deleteUnit: 'api/units/delete',
  createUnit: 'api/units',

  //Designation
  getAllDesignations: 'api/designations/all',
  getOneDesignation: 'api/designations/find',
  updateDesignation: 'api/designations/update',
  deleteDesignation: 'api/designations/delete',
  createDesignation: 'api/designations/create',

  //Course
  createCourse: 'api/course/create',
  createLesson: 'api/lesson',
  getAllLessons: 'api/lesson',
  createLessonContentVideo: 'api/lesson/content/create/video',
  createLessonContentPdf: 'api/lesson/content/create/pdf',
  createLessonContentQuiz: 'api/lesson/content/create/quiz',
  createComment: 'api/course',
  getComments: 'api/course',
  replyComment: 'api/course/comment',
  rateCourse: 'api/course',
  getAllCourses: 'api/course/contentProvider/all',
  enroll: 'api/course',
  unEnroll: 'api/course',
  updateCourse: 'api/course',
  getCourseById: 'api/course',
  getEnrolledCourses: 'api/users/enrolled_courses',
  getEnterpriseEnrolledCourses: 'api/enterprise',
  getAssignedCourses: 'api/enterprise',
  updateLessonContentWatchedTime: 'api/course/update_lesson_content_watched_time',

  userProfile: 'api/users/profile',
  deleteFileFromCloudinary: 'api/lesson/content/cloudinaryId',
  deleteContent: 'api/lesson/content',
  deleteLesson: 'api/lesson',
  updateContent: 'api/lesson/content',
  getOneContent: 'api/lesson/content',
  getAllCoursesByCompany: 'api/company/courses',
  assignCourseToIndividual: 'api/course/individual_assign',
  assignCourseToDepartment: 'api/course/department_assign',
  assignCourseToDivision: 'api/course/division_assign',
  assignCourseToUnit: 'api/course/unit_assign',
  courseProgressUpdate: 'api/course/progressUpdate',
  savedCourses: 'api/users/saved_courses',
  toggleSaveCourse: 'api/course',
  toggleLikeCourse: 'api/course',
  likedCourses: 'api/users/liked_courses',
  deleteCourse: 'api/course',
  unassign: 'api/course/individual_unassign',
  generateReport: 'api/course',

  //Staff
  createEnterpriseUser: 'api/enterprise/create_user',
  getDashboardContents: 'api/enterprise/v2/dashboard',
  getActiveEnterpriseStaffs: 'api/enterprise/active_staff',
  getAllEnterpriseStaffs: 'api/enterprise/all_staff',

  getOneEnterpriseUser: 'api/enterprise/user',
  assignedCourses: 'api/enterprise',
  assignedLearningPaths: 'api/enterprise',
  profile: 'api/company/mine',
  updateEnterpriseUser: 'api/company/update',
  activateDeactivateStaff: 'api/enterprise/user',
  updateOneEnterpriseUser: 'api/enterprise/user',
  uploadAvatar: 'api/users/upload_avatar',
  uploadUserAvatar: 'api/users',

  sendMessage: 'api/enterprise/user',
  receivedMessages: 'api/enterprise/messages/received',

  //LearningPath
  createLearningPath: 'api/learning_path/create',
  getAllLearningPaths: 'api/learning_path/all',
  getOneLearingPath: 'api/learning_path',
  deleteLearingPath: 'api/learning_path',
  updateLearningPath: 'api/learning_path',
  findAll: 'api/learning_path/all',
  assignLpToIndividual: 'api/learning_path/individual_assign',
  assignLpToDepartment: 'api/learning_path/department_assign',
  assignLpToDivision: 'api/learning_path/division_assign',
  assignLpToUnit: 'api/learning_path/unit_assign',

  //Mentorship
  createMentor: 'api/mentor/create',
  getAllMentors: 'api/mentor/all',
  getOneMentor: 'api/mentor',
  deleteMentor: 'api/mentor',
  updateMentor: 'api/mentor',
  assignMentors: 'api/mentor/assign_mentees',

  //Notification
  allNotifications: 'api/notification/all',
  readNotification: 'api/notification',

  //Quiz
  assessmentResultHistory: 'api/assessment',
  markAssessment: 'api/assessment',

  //WeeklyGoal
  setWeeklyGoal: 'api/enterprise/set_goal',

  //Designation
  getAllSchedulesByUsers: 'api/learning_schedule',
  createLearningSchedule: 'api/learning_schedule',
  getSingleScheduleByUser: '/api/learning_schedule',
  updateLearningSchedule: 'api/learning_schedule',
};
